import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const DeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  gap: ${getToken('spacing-2')};

  ${screen.md} {
    align-items: center;
    flex-direction: row;
  }

  [role='progressbar'] {
    flex-grow: 1;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  gap: ${getToken('spacing-2')};

  ${screen.md} {
    justify-content: flex-start;
  }
`
